import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './core/components/layout/layout.component';
import { AuthGuard } from './core/guard/auth.guard';
import { LoginGuard } from './core/guard/login.guard';
import { AppResolver } from './core/resolvers/app.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    canActivate: [LoginGuard],
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'patient',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./patient-dashboard/patient-dashboard.module').then(
        (m) => m.PatientDashboardModule
      ),
  },
  {
    path: 'shell-user',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./shell-user-dashboard/shell-user-dashboard.module').then(
        (m) => m.ShellUserDashboardModule
      ),
  },
  {
    path: 'pharmacist-consultation-dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pre-assessment-dashboard/pre-assessment-dashboard.module').then(
        (m) => m.PreAssessmentDashboardModule
      ),
  },
  {
    path: 'portal',
    component: LayoutComponent,
    resolve: { appData: AppResolver },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: 'transfer-prescription',
    component: LayoutComponent,
    resolve: { appData: AppResolver },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./shared-component/shared-component.module').then((m) => m.SharedComponentModule),
      },
    ],
  },
  {
    path: 'visits/dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./core/components/wylo/visits/visit-dashboard/visit-dashboard.module').then((m) => m.VisitDashboardModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
